import React, { Component } from "react";
import { connect } from "react-redux";
import "./legalRemarks.scss";
import util from "../../_helpers/util";
import DatePicker from "react-datepicker";
import { apis } from "../../actions";
import { confirmAlert } from "react-confirm-alert";
import { validateCertificationDocuments } from "../../_helpers/certificationValidation";

const step = 6;
const page = "legalRemarks";
class LegalRemarks extends Component {
  constructor(props) {
    super(props);

    const formattedDate = new Date();
    this.state = {
      newApplication: true,
      canApply: true,
      form: {
        Veteran: "no",
        Race: "",
        gender: "",
        FullName: "",
        txtDate: formattedDate,
        agreement: [],
        step: step,
      },
    };
  }

  blur(event) {
    util.blur(event);
  }

  setValue(event) {
    if (event.target.classList.contains("aplcn-has-error")) {
      event.target.classList.remove("aplcn-has-error");
    }
    util.setValue.call(this, event);
    if (util.isblurred(event.target)) {
      var valid = util.validate(event.target);
    }
  }
  handleDateChange(name, date) {
    util.setValue.call(this, null, {
      value: date,
      name: name,
    });
  }

  submitForm(event) {
    event.preventDefault();
    if (!this.state.canApply) {
      confirmAlert({
        title: "Application Update Restricted",
        message: "You cannot update your job application as it may currently be under review or archived. Please email hr@firestormfire.com if you believe this is incorrect.",
        buttons: [
          {
            label: "Close",
            onClick: () => {},
          },
        ],
      });
      return;
    }
    if (!util.forceVlidate(document.getElementById(page))) {
      return;
    }

    const prefetchedData = this.props.api || {};
    const aplicationDetail = prefetchedData.aplicationDetail || {};
    const certStatus = (prefetchedData.CertificationStatus || []).find(
      (cert) => cert.id == aplicationDetail.certification_status_id
    );
    const certName = certStatus ? certStatus.value : "";

    if (!certName) {
      return confirmAlert({
        title: "ERROR",
        message:
          "The current certification status field is required, If you don't have any training please choose No Training. Please go back to the Certification tab to complete it.",
        buttons: [
          {
            label: "Close",
            onClick: () => {},
          },
        ],
      });
    }

    const userCertIds = (aplicationDetail.filequalification || []).map(
      (cert) => parseInt(cert.type) || parseInt(cert.certificate_id)
    );
    const { valid: validCert, errorMsg } = validateCertificationDocuments(
      prefetchedData.ListCertificateType,
      certName,
      userCertIds
    );
    if (!validCert) {
      return confirmAlert({
        customUI: ({ title, message, onClose }) => (
          <div className="react-confirm-alert-body">
            <h1>{title}</h1>
            <p dangerouslySetInnerHTML={{ __html: message }}></p>
            <div
              className="react-confirm-alert-button-group"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button onClick={onClose}>Close</button>
            </div>
          </div>
        ),
        title: "ERROR",
        message: `${errorMsg} Please go back to the Certification tab to upload the required documents.`,
        buttons: [
          {
            label: "Close",
            onClick: () => {},
          },
        ],
      });
    }

    "function" === typeof this.props.action &&
      this.props.action({ ...this.state.form, step }, step);
  }

  componentDidMount() {
    this.setDefaultData();
    this.props.dispatch(apis.fetchProviderNumber());
  }

  componentDidUpdate(prevProps) {
    const applicationDetails =
      this.props.api && this.props.api.aplicationDetail;
    const prevApplicationDetails =
      prevProps.api && prevProps.api.aplicationDetail;
    const shouldSetDefaultValues = !!(
      (applicationDetails && applicationDetails.hash) !==
      (prevApplicationDetails && prevApplicationDetails.hash)
    );

    if (shouldSetDefaultValues) {
      this.setDefaultData();
    }
  }

  setDefaultData() {
    let newApplication = false;

    if (this.props.api && this.props.api.aplicationDetail) {
      var data = this.props.api.aplicationDetail,
        obj = Object.assign({}, this.state.form);

      if (
        !data.date ||
        data.date == "" ||
        new Date(data.date).getFullYear() < new Date().getFullYear()
      ) {
        newApplication = true;
      } else {
        newApplication = false;
      }

      let form = util._merge(obj, data, {
        Veteran: "veteran",
        FullName: "full_name",
        Race: "race_id",
        txtDate: {
          target: "date",
          filter: "date",
        },
      });

      if (form.agreement && typeof form.agreement === "string") {
        form.agreement = form.agreement.toLowerCase();
      }

      this.setState({
        canApply: data.can_apply,
        form,
        sms_provider_opt_out:
          this.props.api.aplicationDetail.sms_provider_opt_out,
      });
    }
  }

  render() {
    var prefetchedData = this.props.api || {};
    const isVeteran = this.props?.api?.aplicationDetail?.veteran;
    return (
      <div className="aplcn-form aplcn-form-two">
        <form method="post" onSubmit={this.submitForm.bind(this)} id={page}>
          <div className="aplcn-form-section-head">
            <h4>Legal And Final Remarks</h4>
          </div>
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                <p className="aplcn-desc aplcn-txt-big">
                  <i className="fa fa-info-circle" aria-hidden="true" /> The
                  following questions are optional, but we are required to ask
                  them due to our contractual obligations with the US Federal
                  Government.
                </p>
                <p className="aplcn-desc aplcn-txt-big">
                  Firestorm reaffirms its belief and commitment to equal
                  employment opportunity for all employees and applicants for
                  employment in all terms and conditions of employment.
                </p>
                <p className="aplcn-desc aplcn-txt-big">
                  Firestorm has developed and maintained a written Affirmative
                  Action Program (AAP). Firestorm’s Chief Executive Officer
                  supports the affirmative action program and urges each
                  employee to commit to carrying out the intent of this policy.
                  Firestorm maintains an audit and reporting system to determine
                  overall compliance with its equal employment opportunity
                  mandates. The EEO Administrator oversees the affirmative
                  action plan development, modification, implementation,
                  effectiveness, and reporting requirements and conducts
                  management updates. Firestorm invites any employee to review
                  Firestorm’s written Affirmative Action Plan. This plan is
                  available for inspection upon request during normal business
                  hours at the Human Resources office.
                </p>

                <p className="aplcn-desc aplcn-txt-big">
                  As part of Firestorm’s commitment to this overall process, it
                  will seek to ensure that all aspects of employment, including
                  recruitment, selection, job assignment, training,
                  compensation, benefits, discipline, promotion, transfer,
                  layoff, and termination processes remain free of illegal
                  discrimination based upon race, color, religion, sex, and
                  national origin, disability (as defined under Section 503 of
                  the Rehabilitation Act of 1973) or protected veteran status
                  (as defined under Vietnam Era Veterans’ Readjustment
                  Assistance Act of 1974). Firestorm ensures that all employment
                  decisions are based only on valid job requirements. Regular
                  review helps to ensure compliance with this policy.
                </p>

                <p className="aplcn-desc aplcn-txt-big">
                  Firestorm will ensure that employees and applicants shall not
                  be subjected to harassment due to their status described
                  above, or any harassment, intimidation, threats, coercion, or
                  discrimination because they have engaged in or may engage in
                  any of the following activities: (I) filing a complaint with
                  Firestorm or with federal, state, or local agencies regarding
                  status covered under this AAP, (2) assisting or participating
                  in any investigation, compliance review, hearing, or any other
                  activity related to the administration of any federal, state,
                  or local equal employment opportunity or affirmative action
                  statute pertaining to the status covered under this AAP; (3)
                  opposing any act or practice made unlawful by section 503
                  and/or VEVRAA, and (4) exercising any other right protected by
                  section 503 and/or VEVRAA or its implementing regulations in
                  this part.
                </p>
              </div>
            </div>
          </div>

          <div className="aplcn-form-row-main  aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <select
                  name="form.gender"
                  value={this.state.form.gender}
                  required
                  onBlur={this.blur.bind(this)}
                  onChange={this.setValue.bind(this)}
                  title="Gender"
                >
                  <option value="">--- Select Gender ---</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <select
                  required
                  onBlur={this.blur.bind(this)}
                  onChange={this.setValue.bind(this)}
                  className=""
                  name="form.Race"
                  value={this.state.form.Race}
                  title="Race"
                >
                  <option value="">--- Select Race ---</option>
                  {prefetchedData.Race &&
                    prefetchedData.Race.map((item, index) => {
                      return (
                        <option value={item.id} key={"Race" + item.id}>
                          {item.value}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
          </div>

          <div className="aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">Are you a Veteran</h5>
          </div>

          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="Yes"
                  type="radio"
                  id="Veteran1"
                  onChange={this.setValue.bind(this)}
                  name="form.Veteran"
                  checked={this.state.form.Veteran === "Yes"}
                  defaultChecked={isVeteran === "Yes"}
                />
                <label htmlFor="Veteran1">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="No"
                  type="radio"
                  id="Veteran23"
                  onChange={this.setValue.bind(this)}
                  name="form.Veteran"
                  checked={this.state.form.Veteran === "No"}
                  defaultChecked={isVeteran === "No"}
                />
                <label htmlFor="Veteran23">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          <div>
            <h4>SMS Notification Preference</h4>
            <small style={{ display: "block", color: "#666" }}>
              You can skip this. You will still receive important job-related
              updates via email.
            </small>
            {this.state.sms_provider_opt_out && this.props.api.provider_number ? (
              <p>You've opted out of SMS notifications with our provider. To opt back in, please reply 'START' to {this.props.api.provider_number}. Once done, your SMS notifications will be enabled.</p>
            ) : (
              <>
                <input
                  value="yes"
                  type="checkbox"
                  id="sms_consent"
                  onChange={this.setValue.bind(this)}
                  name="form.sms_consent"
                  title="Form Agreement"
                  className="aplcn-visible-check"
                  checked={util.defaultChecked(
                    "yes",
                    this.state.form.sms_consent
                  )}
                />
                <label style={{ display: "contents"}}>
                  I consent to receive SMS notifications regarding my job
                  application status.
                </label>
              </>
            )}
          </div>

          <div className="aplcn-form-section-head">
            <div className="aplcn-tearms-and-conditions">
              <p>
                Submission of false information is grounds for employment and
                candidacy termination.
              </p>
              <p>
                I hereby authorize Firestorm Wildland Fire Suppression, Inc. to
                thoroughly investigate my references, work record, education and
                other matters related to my suitability for employment
                (excluding criminal background information) unless otherwise
                specified above. I further, authorize the references I have
                listed to disclose to the company any and all letters, reports
                and other information related to my work records, without giving
                me prior notice of such disclosure. In addition, I hereby
                release the Company, my former employers and all other persons,
                corporations, partnerships and associations from any and all
                claims, demands or liabilities arising out of or in any way
                related to such investigation or disclosure.
              </p>
              <p>
                I verify that all information provided on this application is in
                fact true to the best of my knowledge and understand that if
                information is not true, my candidacy and/or employment will be
                terminated. By filling out your name and dating below is a legal
                agreement between you (the applicant) and Firestorm Inc.
              </p>

              <div className="aplcn-form-row-main">
                <ul className="aplcn-checklist inline-radios">
                  <li className="aplcn-green-check">
                    <input
                      value="yes"
                      type="checkbox"
                      id="agreement_12"
                      onChange={this.setValue.bind(this)}
                      name="form.agreement"
                      required
                      title="Form Agreement"
                      checked={this.state.form.agreement === "yes"}
                      className="aplcn-visible-check"
                      checked={util.defaultChecked(
                        "yes",
                        this.state.form.agreement,
                      )}
                    />
                    <label htmlFor="agreement_12">
                      <span className="aplcn-check-label">
                        I agree to the above statement
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="aplcn-form-row-main  aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  type="text"
                  placeholder="Type legal full name"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.FullName}
                  name="form.FullName"
                  required
                  title="Legal Full Name"
                />
              </div>
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <DatePicker
                  className="legal-remark-date-picker"
                  selected={this.state.form.txtDate}
                  showYearDropdown
                  onChange={this.handleDateChange.bind(this, "form.txtDate")}
                  placeholderText="Todays Date"
                  // dateFormat={util._datePickerFormat()}
                  required
                  disabled
                  minDate={new Date()}
                  title="Date"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 aplcn-form-main-actionbar">
              <div className="aplcn-form-actionbar">
                <button
                  onClick={this.back.bind(this)}
                  type="button"
                  disabled=""
                  className="aplcn-prev-button"
                >
                  Previous
                </button>
                <button type="submit" className="aplcn-next-btn">
                  {this.state.newApplication ? "Save" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }

  back(event) {
    event.preventDefault();
    this.props.back(step);
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(LegalRemarks);
export { connectedApp as LegalRemarks };
